const BLOCK_TAG = /<(p|h[1-6]|ul|ol|li|blockquote|pre|div|details|hr|table)\b/i;

// Plain-text descriptions (query-param overrides, never-rendered legacy text)
// carry their line breaks as \n and need pre-line. Rendered HTML carries
// them as tags, and pre-line would turn stray newlines into blank lines.
export function descriptionWhiteSpace(description) {
  return typeof description === 'string' && BLOCK_TAG.test(description) ? 'normal' : 'pre-line';
}
